import React, { FC } from 'react'

import { Icon, IconColor, IconName } from '../Icon'

interface Props {
  icon?: IconName
  title?: string
  text: string
  noShadow?: boolean
}

export const InfoPlaceholder: FC<Props> = ({
  icon = IconName.search,
  title = 'Noch nichts zu finden',
  text,
  noShadow = false
}: Props) => {
  return (
    <div className={`infoplaceholder mt-2${noShadow ? ' infoplaceholder--no-shadow' : ''}`}>
      <Icon name={icon} color={IconColor.GRAY_2} />
      <h2>{title}</h2>
      <p>{text}</p>
    </div>
  )
}
